import type { Client, RequestContext } from "../client";
import type { ApprovalPolicyResource } from "../resources/approvalPolicies/approvalPolicyResource";
import type { PaginatedCollection } from "../resources/index";
export class ApprovalPolicyRepository {
    protected client: Client;
    baseUrl = "~/api/spaces/{spaceId}/approvalpolicies";
    constructor(client: Client, private readonly requestContext: RequestContext) {
        this.client = client;
    }
    async get(id: string): Promise<ApprovalPolicyResource> {
        const args = { id };
        return await this.client.get<ApprovalPolicyResource>(this.requestContext, `${this.baseUrl}/{id}`, args);
    }
    async getAll(skip: number, take: number): Promise<PaginatedCollection<ApprovalPolicyResource>> {
        const args = { skip, take };
        return await this.client.get<PaginatedCollection<ApprovalPolicyResource>>(this.requestContext, `${this.baseUrl}/all{?skip}{&take}`, args);
    }
    async create(resource: ApprovalPolicyResource): Promise<ApprovalPolicyResource> {
        return await this.client.post<ApprovalPolicyResource>(this.requestContext, `${this.baseUrl}`, resource);
    }
    async modify(resource: ApprovalPolicyResource): Promise<ApprovalPolicyResource> {
        return await this.client.put<ApprovalPolicyResource>(this.requestContext, `${this.baseUrl}/{id}`, resource, { id: resource.Id });
    }
    async delete(id: string): Promise<void> {
        await this.client.delete(this.requestContext, `${this.baseUrl}/{id}`, null, { id });
    }
}
